import { ICON_NAMES } from '@/config/config';

import { ApplicationType } from '../../../../../../config/types';
import { MenuItemType } from '../types/MenuItemType';

export const APPLICATION_TYPE_MENU_ITEMS: MenuItemType[] = [
  {
    value: ApplicationType.CONSUMER_LOAN,
    labelTextId: ApplicationType.CONSUMER_LOAN,
    iconName: ICON_NAMES.CONSUMER_LOAN,
  },
  {
    value: ApplicationType.AUTO,
    labelTextId: ApplicationType.AUTO,
    iconName: ICON_NAMES.AUTO,
  },
  {
    value: ApplicationType.CREDIT_LINE,
    labelTextId: ApplicationType.CREDIT_LINE,
    iconName: ICON_NAMES.CREDIT_LINE,
  },
  {
    value: ApplicationType.ORDER,
    labelTextId: ApplicationType.ORDER,
    iconName: ICON_NAMES.ORDER,
  },
  {
    value: ApplicationType.PAY_BY_LINK,
    labelTextId: ApplicationType.PAY_BY_LINK,
    iconName: ICON_NAMES.PAY_BY_LINK,
  },
  {
    value: ApplicationType.CARD_PAYMENT,
    labelTextId: ApplicationType.CARD_PAYMENT,
    iconName: ICON_NAMES.CARD_PAYMENT,
  },
  {
    value: ApplicationType.A2A_PAYMENT,
    labelTextId: ApplicationType.A2A_PAYMENT,
    iconName: ICON_NAMES.A2A_PAYMENT,
  },
  {
    value: ApplicationType.CARD,
    labelTextId: ApplicationType.CARD,
    iconName: ICON_NAMES.CARD,
  },
];
